<div class="compound-navbar-link">
  <a
    #anchor
    [routerLink]="navLink"
    [state]="captureFocusNavState"
    [class.active]="isActive"
    [attr.aria-current]="ariaCurrent"
    [attr.aria-label]="ariaLabel"
  >
    <ng-content></ng-content>
  </a>
</div>
